const loginMap = {
  jco: [{ sns: 'google', label: 'Login with Google' }],
  default: [
    { sns: 'google', label: 'Login with Google' },
  ],
};

export { loginMap };
